<template lang="pug">
FcwProfileAuthTemplate
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'profile-auth',
});

const { seoData } = await useCmsProfileSettings();

useClientSeoMeta(seoData);
</script>
